<template>
  <div class="help">
    <b-sidebar
      id="sidebar-help"
      :class="$style['help-body']"
      right
      no-header-close
      no-header
      backdrop
      v-model="toggleSideBar"
      @hidden="closeMe"
      z-index="9"
    >
      <div :class="$style['bg-blue']">
        <div :class="$style['title']">
          <h5>Find a Guide ({{ guidesArray.length }})</h5>
          <div @click="closeMe">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div :class="$style.search">
          <input type="text" />
          <span :class="$style['search-icon']">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16668C4.75617 3.16668 2.66683 5.25601 2.66683 7.83334C2.66683 10.4107 4.75617 12.5 7.3335 12.5C9.91083 12.5 12.0002 10.4107 12.0002 7.83334C12.0002 5.25601 9.91083 3.16668 7.3335 3.16668ZM1.3335 7.83334C1.3335 4.51963 4.01979 1.83334 7.3335 1.83334C10.6472 1.83334 13.3335 4.51963 13.3335 7.83334C13.3335 11.1471 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.1471 1.3335 7.83334Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8682 11.3108 10.8682 11.5712 11.1286L14.4712 14.0286C14.7315 14.2889 14.7315 14.711 14.4712 14.9714C14.2108 15.2317 13.7887 15.2317 13.5284 14.9714L10.6284 12.0714C10.368 11.811 10.368 11.3889 10.6284 11.1286Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
        <!-- <div :class="$style.tags">
          <span class="tag">
            <h5>Search tag 1</h5>
          </span>
          <div :class="$style['btn-tag']">+ Add Tag</div>
        </div> -->
        <br /><br />
      </div>
      <div class="mt-2" :class="$style['bg-ff']">
        <div :class="$style.guides">
          <!-- <div
            v-for="(cond, index) in guidesArray.slice(1, 2)"
            :key="index"
            :class="$style['guide-card']"
            :aria-expanded="onVisibleSlider ? 'true' : 'false'"
            :aria-controls="`sidebar_guide_${cond.user.userId}`"
            @click="toggleCollapse(cond.user.userId)"
          >
            <div :class="$style['guide-badge']">
              <h4 :class="$style.booked">Booked</h4>
            </div>
            <div :class="$style.user">
              <img :src="cond.user.imgURL" alt="" />
              <div :class="$style['user-info']">
                <h3>{{ cond.user.firstname }}</h3>
                <p>Build Technology</p>
              </div>
            </div>
            <div :class="$style.foot">
              <button class="btn-fill">Charity</button>
              <h5 class="ml-2">$75 /session</h5>
              <div :class="$style.social">
                <a href="https://google.com" target="_blank">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 20.0002C15.5228 20.0002 20 15.523 20 10.0002C20 4.47734 15.5228 0.000183105 10 0.000183105C4.47715 0.000183105 0 4.47734 0 10.0002C0 15.523 4.47715 20.0002 10 20.0002Z"
                      fill="#3B5998"
                    />
                    <path
                      d="M12.5139 10.3911H10.7295V16.9282H8.02602V10.3911H6.74023V8.09368H8.02602V6.60699C8.02602 5.54385 8.53103 3.87909 10.7536 3.87909L12.7561 3.88747V6.11749H11.3031C11.0648 6.11749 10.7297 6.23657 10.7297 6.74372V8.09582H12.7501L12.5139 10.3911Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <a href="https://google.com" target="_blank">
                  <svg
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 2.79748C19.2641 3.12382 18.4733 3.34439 17.6433 3.44359C18.4905 2.93574 19.1411 2.13162 19.4475 1.1735C18.6547 1.64367 17.7765 1.98516 16.8419 2.16922C16.0933 1.37175 15.027 0.873413 13.8468 0.873413C11.5807 0.873413 9.74344 2.71057 9.74344 4.97656C9.74344 5.29815 9.7798 5.61133 9.84974 5.91164C6.43952 5.74053 3.41607 4.10696 1.3923 1.6245C1.0391 2.23052 0.836753 2.93538 0.836753 3.68734C0.836753 5.11088 1.56121 6.36681 2.6622 7.10261C1.98954 7.08132 1.35689 6.89675 0.803614 6.58942C0.803321 6.60654 0.803321 6.62373 0.803321 6.641C0.803321 8.62907 2.21771 10.2875 4.09481 10.6644C3.75047 10.7582 3.38798 10.8083 3.01372 10.8083C2.74933 10.8083 2.49226 10.7826 2.24178 10.7347C2.76389 12.3649 4.27923 13.5512 6.07476 13.5843C4.67047 14.6848 2.9012 15.3408 0.978821 15.3408C0.647646 15.3408 0.321007 15.3214 0 15.2835C1.81587 16.4477 3.97271 17.127 6.28992 17.127C13.8372 17.127 17.9644 10.8746 17.9644 5.45237C17.9644 5.27445 17.9604 5.09749 17.9525 4.92155C18.7542 4.34304 19.4499 3.62033 20 2.79748Z"
                      fill="#55ACEE"
                    />
                  </svg>
                </a>
                <a href="https://google.com" target="_blank">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.0032 5.35107C7.88381 5.35107 5.3584 7.87924 5.3584 10.9959C5.3584 14.1153 7.88656 16.6407 11.0032 16.6407C14.1226 16.6407 16.6481 14.1126 16.6481 10.9959C16.6481 7.87649 14.1199 5.35107 11.0032 5.35107ZM11.0032 14.6598C8.97831 14.6598 7.33931 13.0199 7.33931 10.9959C7.33931 8.97191 8.97923 7.33199 11.0032 7.33199C13.0272 7.33199 14.6671 8.97191 14.6671 10.9959C14.6681 13.0199 13.0281 14.6598 11.0032 14.6598Z"
                      fill="#FF0FFF"
                    />
                    <path
                      d="M15.5359 0.0691044C13.5119 -0.0253122 8.49863 -0.0207289 6.47279 0.0691044C4.69263 0.152521 3.12238 0.582438 1.85646 1.84835C-0.259208 3.96402 0.0112083 6.81486 0.0112083 10.9958C0.0112083 15.2748 -0.227125 18.0596 1.85646 20.1432C3.98038 22.2662 6.87246 21.9884 11.0039 21.9884C15.2425 21.9884 16.7055 21.9912 18.2043 21.4109C20.242 20.6199 21.7802 18.7984 21.9305 15.5269C22.0259 13.5019 22.0204 8.4896 21.9305 6.46377C21.749 2.60186 19.6765 0.259771 15.5359 0.0691044ZM18.7396 18.7434C17.3527 20.1304 15.4286 20.0066 10.9773 20.0066C6.39396 20.0066 4.55604 20.0744 3.21496 18.7297C1.67038 17.1924 1.94996 14.7239 1.94996 10.9811C1.94996 5.91652 1.43021 2.2691 6.51313 2.00877C7.68096 1.96752 8.02471 1.95377 10.9645 1.95377L11.0057 1.98127C15.8906 1.98127 19.7232 1.46977 19.9533 6.55177C20.0055 7.71136 20.0175 8.05969 20.0175 10.9949C20.0165 15.525 20.1027 17.3739 18.7396 18.7434Z"
                      fill="#FF0FFF"
                    />
                    <path
                      d="M16.8718 6.44724C17.6003 6.44724 18.1909 5.85667 18.1909 5.12816C18.1909 4.39965 17.6003 3.80908 16.8718 3.80908C16.1433 3.80908 15.5527 4.39965 15.5527 5.12816C15.5527 5.85667 16.1433 6.44724 16.8718 6.44724Z"
                      fill="#FF0FFF"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div> -->

          <!-- <h4 :class="$style.best">Best Guide (20)</h4> -->
          <guide-card
            v-for="(cond, index) in guidesArray"
            :key="`${index}_toogle`"
            :guide="cond"
            :cardStyle="$style"
            @toggleCollapse="toggleCollapse"
          />
        </div>
      </div>
    </b-sidebar>

    <transition name="slide-fade">
      <guide-detail
        :idCollapses="userId"
        :onVisible="onVisibleSlider"
        :guides="guideDetails"
        @show-booking="showBooking"
      />
    </transition>

    <transition name="slide-fade">
      <guide-book
        :key="refreshBooking"
        :onVisible="visibleBooking"
        :guide="guideDetails"
        :session="session"
        @session-booked="bookingDone"
      />
    </transition>
  </div>
</template>
<script>
import guideCard from "../guideCard";
import guideBook from "../guideBook";
import guideDetail from "../guideDetail";
export default {
  name: "Help",
  props: ["show"],
  components: {
    guideCard,
    guideDetail,
    guideBook
  },
  data() {
    return {
      userId: null,
      toggle: this.show,
      visibleBooking: false,
      session: {},
      onVisibleSlider: false,
      closeHelpSidebar: false,
      guideDetails: [],
      guidesArray: [],
      refreshBooking: 1
    };
  },
  mounted() {
    this.$store.dispatch("listings/getListGuides");
    this.guidesArray = this.$store.getters["listings/listGuides"];
    // console.log("guidesArray", this.guidesArray);
  },
  watch: {
    show(n) {
      this.toggleSideBar = n;
    }
  },
  computed: {
    toggleSideBar: {
      get() {
        return this.toggle;
      },
      set(val) {
        this.toggle = val;
      }
    }
  },
  methods: {
    showBooking(session) {
      this.session = session;
      this.visibleBooking = !this.visibleBooking;
    },
    bookingDone() {
      this.refreshBooking++;
    },
    // getCunductorInfo(id) {
    //   if(id !== null) {
    //     console.log("id", id);
    //     return this.guidesArray.filter((items, key) => items.user.userId === id)
    //   }
    //   // Object.assign({}, { user: data.user }, { details: profile !== undefined ? profile.plans : this.guideInfo })
    // },
    toggleCollapse(event) {
      this.userId = event;

      this.guideDetails = this.guidesArray.filter(
        (items, key) => items.user.userId === this.userId
      )[0];

      this.onVisibleSlider = !this.onVisibleSlider;
    },
    closeMe(event) {
      this.toggleSideBar = false;
      this.$emit("closeHelp");
    },
    showGuideModel() {
      this.$emit("showGuideModel");
    }
  }
};
</script>

<style lang="scss" module>
.hide-name {
  width: 135px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hide-describe {
  display: inline-block !important;
  width: 170px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.help-overlay {
  background-color: transparent;
  z-index: 10;
}
.help-body {
  overflow-y: scroll;

  /* width */
  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #474d52 !important;
    border-radius: 10px !important;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555 !important;
  }

  .bg-blue {
    background-color: var(--theme-color);
    padding: 10px 15px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h5 {
        font-family: "Nunito", sans-serif;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: white;
        margin: 0;
      }
      div {
        cursor: pointer;
      }
    }
    .search {
      position: relative;
      margin-top: 25px;
      margin-bottom: 5px;
      // margin: 15px 0;
      input {
        height: 39px;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 100px;
        border: none;
        padding: 10px 25px;
        color: white;
        font-family: "Nunito", sans-serif;
        &:focus {
          outline: none;
        }
      }
      .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .tags {
      margin: 15px 0;
      .tag {
        padding: 7px 10px;
        display: inline-block;
        border-radius: 20px;
        background-color: rgba(255, 255, 255, 0.1);
        h5 {
          color: white;
          margin: 0;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          font-family: "Nunito", sans-serif;
        }
      }
    }
    .btn-tag {
      padding: 7px 10px;
      display: inline-block;
      color: white;
      margin: 0;
      height: 30px;

      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      font-family: "Nunito", sans-serif;
    }
  }
  .bg-ff {
    background-color: #fff;
    padding: 55px 5px 15px 15px;
    // height: 100%;
    position: fixed;
    z-index: 1;
    width: 98%;
    height: auto;
    overflow-y: scroll;
    margin-right: 10px;
    &::-webkit-scrollbar-track {
      background: #fff !important;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #474d523f !important;
      border-radius: 10px !important;
      margin-left: -10px;
      cursor: pointer;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #474d5259 !important;
    }

    .guides {
      margin-top: -60px;
      .guide-card {
        margin: 10px 0;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
        /*height: 120px;*/
        position: relative;
        padding: 15px;
        /*width: 265px;*/
        height: 118px;
        cursor: pointer;
        .guide-badge {
          position: absolute;
          top: 16px;
          right: 15px;
          .booked {
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            font-family: "Nunito", sans-serif;
            color: #6aa84f;
          }
          .rating {
            margin: 0;
            line-height: 15px;
            span {
              font-weight: 600;
              font-size: 14px;
              line-height: 19px;
              color: #474d52;
              font-family: "Nunito", sans-serif;
            }
          }
        }
        .user {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            border-radius: 50%;
            height: 60px;
            width: 60px;
            object-fit: cover;
            margin-right: 15px;
          }
          .user-info {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;
            h3 {
              font-family: "Nunito", sans-serif;
              font-weight: normal;
              font-size: 16px;
              line-height: 22px;
              color: #474d52;
            }
            p {
              font-family: "Nunito", sans-serif;
              font-weight: normal;
              font-size: 12px;
              line-height: 16px;
              display: flex;
              align-items: center;
              color: #a1b1ba;
            }
          }
        }
        .foot {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 10px;
          h5 {
            font-family: "Nunito", sans-serif;
            font-size: 14px;
            line-height: 19px;
            font-weight: 600;
            margin: 0;
            color: #474d52;
          }
          .social {
            a {
              margin: 0 5px;
            }
          }
        }
      }
    }
  }
}
/*}*/
/* width */
::-webkit-scrollbar {
  width: 6px;
}

button:hover,
a:hover {
  box-shadow: 0px 2px 6px 0px #cbcbcb;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.btn-fill {
  font-family: "Nunito", sans-serif;
  width: 62px;
  height: 24px;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  padding: 0;
  border-radius: 20px;
}
</style>
